import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { can, useAuth } from "../lib/auth";
import { Eventos } from "../components/bitacora/Eventos";
import { Integridad } from "../components/bitacora/Integridad";
import { Revision } from "../components/bitacora/Revision";
import { Sesiones } from "../components/bitacora/Sesiones";
import { Usuario } from "../components/bitacora/Usuario";

const TABS = [["accesos", "Accesos", "acceso"], ["acciones", "Acciones", "acción"], ["denegados", "Intentos denegados", "denegado"], ["descargas", "Descargas y exportaciones", "lectura_sensible"],
  ["sesiones", "Sesiones activas"], ["usuario", "Expediente del usuario"], ["revision", "Revisión mensual"], ["integridad", "Integridad"]];

export default function Bitacora() {
  const { user } = useAuth();
  const [tab, setTab] = useState("accesos");
  const [usuarios, setUsuarios] = useState([]);
  useEffect(() => { http.get("/audit/usuarios").then((r) => setUsuarios(r.data)).catch(() => null); }, []);
  const esMaster = user?.template === "master" && can(user, "auditoria.administrar");
  const revisar = can(user, "auditoria.revisar");
  const t = TABS.find((x) => x[0] === tab);
  return (
    <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10" data-testid="bitacora-page">
      <div><p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C867A]">Administración · CNBV</p>
        <h1 className="font-serif-display text-4xl font-bold sm:text-5xl">Bitácora de auditoría<span className="text-[#E8643C]">.</span></h1>
        <p className="mt-2 max-w-2xl text-sm text-[#5C5850]">Registro inalterable de accesos, intentos y actividades de todos los usuarios, encadenado con SHA-256 y sellado diariamente. Conservación: 3 años.</p></div>
      <nav className="-mx-4 flex gap-1 overflow-x-auto px-4 pb-1 sm:mx-0 sm:px-0" data-testid="bit-tabs">
        {TABS.map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium transition-colors ${tab === k ? "bg-[#111] text-white" : "bg-white text-[#5C5850] hover:bg-[#F2F0EC]"}`} data-testid={`bit-tab-${k}`}>{l}</button>)}
      </nav>
      {t[2] && <Eventos key={tab} tab={tab} fijo={t[2]} usuarios={usuarios} esMaster={esMaster} />}
      {tab === "sesiones" && <Sesiones esMaster={esMaster} />}
      {tab === "usuario" && <Usuario usuarios={usuarios} esMaster={esMaster} />}
      {tab === "revision" && <Revision puedeRevisar={revisar} />}
      {tab === "integridad" && <Integridad puedeRevisar={revisar} />}
    </main>
  );
}
